import script from "./SolutionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionSection.vue?vue&type=script&setup=true&lang=js"

import "./SolutionSection.vue?vue&type=style&index=0&id=166d3f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166d3f6a"]])

export default __exports__